let aosList = [...document.querySelectorAll('.text-aos')];

let options = {
  rootMargin: '-15%',
  threshold: 0.0
}

let observer = new IntersectionObserver(reveal, options);

function reveal(blocks){
  blocks.forEach((block) => {
    if(block.isIntersecting) {
      for (let i = 0; i < block.target.children.length; i++) {
        var grand = block.target.children
          block.target.children[i].classList.add('animate-now');
          block.target.children[i].style.transitionDelay = 0.1 + (i * 0.05) + 's';
	  };
    }
  })  
}

aosList.forEach(item =>{
 observer.observe(item); 
})